export default "__VITE_ASSET__MX41hx0Z__"